// extracted by mini-css-extract-plugin
export default {"spinnerCard":"Spinner_spinnerCard__aZnpB"};